import React from 'react';
export function StickyAlertBar() {
  return <div className="fixed top-0 left-0 w-full z-50 overflow-hidden bg-orange py-1.5 shadow-sm" data-id="element-183">
      <div className="relative flex overflow-hidden" data-id="element-184">
        <div className="flex shrink-0 animate-[marquee_30s_linear_infinite] gap-0" data-id="element-185">
          {[...Array(8)].map((_, i) => <span key={i} className="shrink-0 px-6 font-black text-sm uppercase tracking-wider text-white whitespace-nowrap" data-id="element-186">
              🔥 SOLO POR HOY 5 BONUS GRATIS
            </span>)}
        </div>
        <div className="flex shrink-0 animate-[marquee_30s_linear_infinite] gap-0" aria-hidden="true" data-id="element-187">
          {[...Array(8)].map((_, i) => <span key={i} className="shrink-0 px-6 font-black text-sm uppercase tracking-wider text-white whitespace-nowrap" data-id="element-188">
              🔥 SOLO POR HOY 5 BONUS GRATIS
            </span>)}
        </div>
      </div>
    </div>;
}